(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mediaQuery && this.setHeaderHeightHandler) {
        this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    isInteractivePanelOpen() {
      const mobileMenuOpen = this.querySelector('header-drawer details[open]');
      const desktopMenuOpen = this.querySelector('header-menu details[open]');
      const searchModalOpen = this.querySelector('details-modal details[open]');

      return Boolean(
        mobileMenuOpen ||
        desktopMenuOpen ||
        searchModalOpen ||
        (this.predictiveSearch && this.predictiveSearch.isOpen)
      );
    }

    onScroll() {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const previousScrollTop = this.currentScrollTop;
      const headerBottom = Number.isFinite(this.headerBounds.bottom)
        ? this.headerBounds.bottom
        : 0;

      this.currentScrollTop = scrollTop;

      if (this.isInteractivePanelOpen()) {
        this.reveal();
        return;
      }

      if (scrollTop <= headerBottom) {
        this.header.classList.remove('scrolled-past-header');
        this.preventReveal = false;
        requestAnimationFrame(this.reset.bind(this));
        return;
      }

      if (scrollTop > previousScrollTop + 2) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventHide) {
          requestAnimationFrame(this.hide.bind(this));
        }

        return;
      }

      if (scrollTop < previousScrollTop - 2) {
        this.header.classList.add('scrolled-past-header');
        this.preventReveal = false;
        requestAnimationFrame(this.reveal.bind(this));
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');

      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
